import { FlowjoCommons } from '@portal/portal-core';

const { Net } = FlowjoCommons;

// Shape of the raw HTTP response resolved by Net.sendJson (typed `unknown` upstream).
interface HttpResponse {
  code: number;
  data: string;
}

// JSON.parse results are untyped by nature, so `data`/`message`/`error` are boundary `any`/`unknown`.
export type WrappedHttpResult =
  | { succeeded: true; data: any }
  | { failed: true; error: number; message: any }
  | { failed: true; error: unknown };

// Wraps HTTP request in safe `succeeded`/`failed` interface
export const wrapHttpRequest = (
  promise: Promise<HttpResponse>,
): Promise<WrappedHttpResult> =>
  promise
    .then(({ code, data }): WrappedHttpResult =>
      code === Net.reponses.OK
        ? { succeeded: true, data: JSON.parse(data).result }
        : { failed: true, error: code, message: JSON.parse(data).message },
    )
    .catch((err: unknown): WrappedHttpResult => ({ failed: true, error: err }));

interface SendActionParams {
  url: string;
  action: unknown;
  authToken?: string | null;
}

export const sendAction = ({
  url,
  action,
  authToken = null,
}: SendActionParams): Promise<WrappedHttpResult> => {
  if (authToken) {
    const headers = { Authorization: `Bearer ${authToken}` };
    // Net.sendJson resolves as `unknown` upstream; it returns the `{ code, data }` HttpResponse shape.
    return wrapHttpRequest(Net.sendJson(url, action, headers) as Promise<HttpResponse>);
  }
  return wrapHttpRequest(Net.sendJson(url, action) as Promise<HttpResponse>);
};
